import React from 'react'

const CentralInventorySummaryTable = ({
    inventoryData,
    startDate,
    endDate,
    formattedDate,
    itemSearchTerm,
    getValidPhysical,
    formatQuantity,
    calculateConsumed,
    calculateClosing,
    calculateDiscrepancy,
    handleFetchDetails
}) => {
    return (
        <div className="mt-4 rounded-md border max-h-[680px] overflow-auto tiny-scrollbar">
            <table className="min-w-full divide-y divide-gray-200 text-sm text-center">
                <thead className="bg-gray-100 bg-opacity-100 shadow-md sticky top-0 z-40">
                    <tr>
                        <th className="p-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Group</th>
                        <th className="p-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Item Name</th>
                        <th className="p-2 text-xs font-medium text-gray-700 uppercase tracking-wider">UOM</th>

                        <th className="p-2 text-xs font-medium text-gray-700 uppercase tracking-wider">
                            Opening<br />
                            ({formattedDate(startDate)})
                        </th>

                        <th className="p-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Received</th>
                        <th className="p-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Wastage</th>
                        <th className="p-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Consumption</th>

                        <th className="p-2 text-xs font-medium text-gray-700 uppercase tracking-wider">
                            Current Level<br />
                            ({formattedDate(endDate)})
                        </th>

                        <th className="p-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Physical</th>
                        <th className="p-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Discrepancy</th>
                    </tr>
                </thead>

                <tbody className="bg-white divide-y divide-gray-100">
                    {inventoryData &&
                        Object.keys(inventoryData).length > 0 ? (
                        Object.entries(inventoryData)
                            .filter(([itemName, item]) => {
                                const matchesItem =
                                    !itemSearchTerm ||
                                    itemName
                                        .toLowerCase()
                                        .includes(
                                            itemSearchTerm.toLowerCase()
                                        );

                                return matchesItem;
                            })
                            .map(([itemName, item]) => {
                                const key = itemName;
                                const physicalCount =
                                    getValidPhysical(itemName);

                                return (
                                    <tr
                                        key={key}
                                        className="hover:bg-gray-100"
                                    >
                                        <td className="px-3 py-2">
                                            {item.group_name}
                                        </td>

                                        <td
                                            className="px-3 py-2"
                                            onClick={() => handleFetchDetails(itemName)}
                                        >
                                            {itemName}
                                        </td>

                                        <td className="px-3 py-2">
                                            {item.uom}
                                        </td>

                                        <td className="px-3 py-2">
                                            {formatQuantity(
                                                item,
                                                item.opening
                                            )}
                                        </td>

                                        <td className="px-3 py-2">
                                            {formatQuantity(
                                                item,
                                                item.total_received
                                            )}
                                        </td>

                                        <td className="px-3 py-2">
                                            {formatQuantity(
                                                item,
                                                item.total_wasted
                                            )}
                                        </td>

                                        <td className="px-3 py-2">
                                            {formatQuantity(
                                                item,
                                                calculateConsumed(
                                                    item,
                                                    physicalCount
                                                )
                                            )}
                                        </td>

                                        <td className="px-3 py-2">
                                            {formatQuantity(
                                                item,
                                                calculateClosing(
                                                    item,
                                                    physicalCount
                                                )
                                            )}
                                        </td>

                                        <td className="px-3 py-2">
                                            {formatQuantity(
                                                item,
                                                physicalCount
                                            )}
                                        </td>

                                        <td className="px-3 py-2">
                                            {formatQuantity(
                                                item,
                                                calculateDiscrepancy(
                                                    item,
                                                    physicalCount
                                                )
                                            )}
                                        </td>
                                    </tr>
                                );
                            })
                    ) : (
                        <tr>
                            <td
                                colSpan={10}
                                className="px-3 py-4 text-gray-500"
                            >
                                No data available
                            </td>
                        </tr>

                    )}
                </tbody>
            </table>
        </div>
    )
}

export default CentralInventorySummaryTable